// extracted by mini-css-extract-plugin
export default {"tupacGrid":"am-z","tupacHeader":"bm-z","tupacHeader2":"cm-z","tupacMenu":"dm-z","tupacMenu2":"em-z","tupacMain":"fm-z","tupacMain2":"gm-z"};